const API_BASE = process.env.REACT_APP_API_URL || "";
export default API_BASE;
